import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { EoPermissionGuard } from 'ngx-eo-web-components';
import { HomeComponent } from '../home/home.component';
import { AuthGuard } from './guards/auth/auth.guard';
import { NotAuthGuard } from './guards/not-auth/not-auth.guard';
import { RoleGuard } from './guards/role/role.guard';
import { AuthComponent } from './pages/auth/auth.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: AuthComponent, canActivate: [NotAuthGuard] },
  {
    path: 'newUserConfirmation',
    loadChildren: () =>
      import('../new-user-confirmation/new-user-confirmation.module').then(
        (m) => m.NewUserConfirmationModule
      ),
    canActivate: [NotAuthGuard],
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('../new-user-confirmation/new-user-confirmation.module').then(
        (m) => m.NewUserConfirmationModule
      ),
    canActivate: [NotAuthGuard],
  },
  {
    path: 'emailConfirmation',
    loadChildren: () =>
      import('../email-confirmation/email-confirmation.module').then(
        (m) => m.EmailConfirmationModule
      ),
    canActivate: [NotAuthGuard],
  },

  {
    path: 'dummy-crud',
    loadChildren: () =>
      import('../dummy-crud/dummy-crud.module').then((m) => m.DummyCrudModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Dummy CRUD',
    },
  },

  {
    path: 'home',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Αρχική' },
  },
  {
    path: 'prescriptions',
    loadChildren: () => import('../prescriptions/prescriptions.module').then((m) => m.PrescriptionsModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Συνταγές',
    },
  },
  {
    path: 'pharmacies',
    loadChildren: () => import('../pharmacies/pharmacies.module').then((m) => m.PharmaciesModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Φαρμακεία',
    },
  },
  {
    path: 'otp-verification',
    loadChildren: () => import('../otp-verification/otp-verification.module').then((m) => m.OTPVerificationModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Επαλήθευση OTP',
    },
  },
  {
    path: 'documents',
    loadChildren: () => import('../document-upload/document-upload.module').then((m) => m.DocumentUploadModule),
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Ανέβασμα Εγγράφου',
    },
  },
  {
    path: 'admin',
    loadChildren: () => import('../admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard, EoPermissionGuard],
    data: {
      permissions: ['ADMIN_VIEW'],
      breadcrumb: 'Διαχείριση',
    },
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('../settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Ρυθμίσεις' },
  },
  {
    path: 'announcements',
    loadChildren: () =>
      import('../announcement-overview/announcement-overview.module').then(
        (m) => m.AnnouncementsModule
      ),
    canActivate: [AuthGuard, RoleGuard],
    data: { permissions: ['ANNOUNCEMENTS'], breadcrumb: 'Ανακοινώσεις' },
  },

  {
    path: 'roles',
    loadChildren: () =>
      import('../roles/roles.module').then((m) => m.RolesModule),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: ['Admin'],
      breadcrumb: 'Ρόλοι Χρηστών',
    },
  },
  {
    path: 'user',
    loadChildren: () => import('../user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Χρήστες', roles: ['Admin', 'Pharmacist', 'ResponsiblePharmacist'] },
  },

  {
    path: 'contact',
    loadChildren: () =>
      import('../contact/contact.module').then((m) => m.ContactModule),
    canActivate: [AuthGuard],
    data: { breadcrumb: 'Επικοινωνία', permissions: ['CONTACT'] },
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'not-authorized',
    component: NotAuthorizedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '*',
    component: HomeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true }),
  ],
  exports: [RouterModule],
})
export class CoreRoutingModule { }
